export default __webpack_public_path__ + "static/media/adidas-mobile-01.7c2672c1.jpg";